module.exports = __webpack_public_path__ + "static/media/hand-holding-magic.1e402279.svg";